<template>
    <div class="search-form">
        <Form :label-width="labelWidth" class="not-star" label-position="left">
            <Row :gutter="16">
                <Col v-for="(item, index) in form" :span="colSpan" :key="index">
                    <template v-if="item.type === 'Input'">
                        <FormItem :label="item.label" :key="index">
                            <Input
                                v-model="item.value"
                                :placeholder="
                                    item.placeholder || '请输入' + item.label
                                "
                                clearable
                                @on-clear="handleSearch"
                                @on-enter="handleSearch"
                                size="small"
                            >
                                <Icon
                                    :type="item.icon || 'ios-search'"
                                    slot="prefix"
                                />
                            </Input>
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'Select'">
                        <FormItem :label="item.label" :key="index">
                            <Select
                                v-model="item.value"
                                :multiple="item.sql === 'in'"
                                :placeholder="
                                    item.placeholder || '请选择' + item.label
                                "
                                clearable
                                @on-change="onSelectChange(item)"
                                size="small"
                            >
                                <Option
                                    v-for="optionItem in item.options"
                                    :key="optionItem.value"
                                    :value="optionItem.value"
                                >
                                    <Icon
                                        v-if="optionItem.icon"
                                        :type="optionItem.icon"
                                        :color="optionItem.color"
                                    />
                                    {{ optionItem.key || optionItem.label }}
                                </Option>
                            </Select>
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'RadioGroup'">
                        <FormItem :label="item.label" :key="index">
                            <RadioGroup v-model="item.value" size="small">
                                <Radio
                                    v-for="(
                                        optionItem, optionKey
                                    ) in item.options"
                                    :key="optionKey"
                                    :label="optionItem.value"
                                    >{{ optionItem.key }}
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'CheckboxGroup'">
                        <FormItem :label="item.label" :key="index">
                            <CheckboxGroup v-model="item.value" size="small">
                                <Checkbox
                                    v-for="(
                                        optionItem, optionKey
                                    ) in item.options"
                                    :key="optionKey"
                                    :label="optionItem.value"
                                    >{{ optionItem.key }}
                                </Checkbox>
                            </CheckboxGroup>
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'Checkbox'">
                        <FormItem :label="item.label" :key="index">
                            <Checkbox v-model="item.value" size="small" />
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'Switch'">
                        <FormItem :label="item.label" :key="index">
                            <i-switch v-model="item.value" size="small" />
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'Daterange'">
                        <FormItem :label="item.label" :key="index">
                            <DatePicker
                                v-model="item.value"
                                format="yyyy年MM月dd日"
                                type="daterange"
                                placement="bottom-end"
                                style="width: 100%; z-index: 999"
                                @on-change="formatDate(item.value)"
                                transfer
                                size="small"
                            />
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'DateTimeRange'">
                        <FormItem :label="item.label" :key="index">
                            <DatePicker
                                v-model="item.value"
                                format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                placement="bottom-end"
                                style="width: 100%; z-index: 999"
                                @on-change="item.value = $event"
                                transfer
                                size="small"
                            />
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'Date'">
                        <FormItem :label="item.label" :key="index">
                            <DatePicker
                                v-model="item.value"
                                format="yyyy年MM月dd日"
                                type="date"
                                size="small"
                                transfer
                            />
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'Cascader'">
                        <FormItem :label="item.label" :key="index">
                            <Cascader
                                :data="item.cascaderData"
                                v-model="item.value"
                                size="small"
                            />
                        </FormItem>
                    </template>
                    <template v-if="item.type === 'SelectObject'">
                        <FormItem :label="item.label" :key="index">
                            <Select
                                v-model="item.value"
                                :placeholder="
                                    item.placeholder || '请选择' + item.label
                                "
                                clearable
                                @on-change="onSelectChange(item)"
                                size="small"
                            >
                                <Option
                                    v-for="optionItem in item.options"
                                    :key="optionItem.value"
                                    :value="optionItem.value"
                                    :label="optionItem.key || optionItem.label"
                                >
                                    <Icon
                                        v-if="optionItem.icon"
                                        :type="optionItem.icon"
                                        :color="optionItem.color"
                                    />
                                    {{ optionItem.key || optionItem.label }}
                                </Option>
                            </Select>
                        </FormItem>
                    </template>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col :span="24" class="search-actions">
                    <Button
                        type="primary"
                        icon="ios-search"
                        @click="handleSearch"
                        class="action-btn"
                    >
                        搜索
                    </Button>
                    <Button
                        icon="md-refresh"
                        @click="resetSearch"
                        style="margin-left: 8px"
                        class="action-btn"
                    >
                        重置
                    </Button>
                    <Button
                        icon="ios-download-outline"
                        @click="handleExport"
                        style="margin-left: 8px"
                        type="success"
                        class="action-btn"
                        v-if="showExport"
                    >
                        导出
                    </Button>

                    <slot name="otherButtons" />
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import search from "@/libs/search";

export default {
    name: "SearchCardNew",
    props: {
        form: {
            type: Array,
            required: true
        },
        labelWidth: {
            type: Number,
            default: 80
        },
        colSpan: {
            type: Number,
            default: 6
        },
        searchBtnColSpan: {
            type: Number,
            default: 6
        },
        tableLoadEvent: {
            type: Function,
            required: true
        },
        tableSearch: {
            type: Object,
            required: true
        },
        showExport: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        filterForm() {
            // 前端过滤
            let formEd = [];
            console.log("form", this.form);
            this.form.forEach(function (element) {
                switch (element.type) {
                    case "Input":
                        if (
                            element.value.replace(/(^s*)|(s*$)/g, "").length
                            !== 0
                        ) {
                            formEd.push(element);
                        }
                        break;
                    case "Checkbox":
                        formEd.push(element);
                        break;
                    case "Switch":
                        formEd.push(element);
                        break;
                    case "Daterange":
                        if (element.value.length > 0) {
                            let dateBegin = element.value[0];
                            let dateEnd = element.value[1];
                            if (dateBegin) {
                                let aJson = new Date(dateBegin).toJSON();
                                if (
                                    aJson.length == 24
                                    && aJson.indexOf("16:00:00") > -1
                                ) {
                                    dateBegin
                                        = this.formatSingleDate(dateBegin);
                                    dateEnd = this.formatSingleDate(dateEnd);
                                    // dateEnd = this.formatSingleDateAddOnyDay(dateEnd);
                                }
                            }
                            if (dateBegin && dateEnd) {
                                formEd.push(
                                    Object.assign({}, element, {
                                        value: JSON.stringify([
                                            dateBegin,
                                            dateEnd
                                        ])
                                    })
                                );
                            }
                        }
                        break;
                    case "DateTimeRange":
                        if (element.value.length > 0) {
                            let dateBegin = element.value[0];
                            let dateEnd = element.value[1];
                            if (dateBegin && dateEnd) {
                                formEd.push(
                                    Object.assign({}, element, {
                                        value: JSON.stringify([
                                            dateBegin,
                                            dateEnd
                                        ])
                                    })
                                );
                            }
                        }
                        break;
                    case "Date":
                        if (
                            element.value.replace(/(^s*)|(s*$)/g, "").length
                            !== 0
                        ) {
                            formEd.push(element);
                        }
                        break;
                    case "Select":
                        if (
                            element.value != null
                            && element.value !== undefined
                        ) {
                            if (Array.isArray(element.value)) {
                                if (element.value.length > 0) {
                                    formEd.push(
                                        Object.assign({}, element, {
                                            value: JSON.stringify(
                                                element.value
                                            )
                                        })
                                    );
                                }
                            }
                            else {
                                let arr = [];
                                arr.push(element.value);
                                formEd.push(
                                    Object.assign({}, element, {
                                        value: JSON.stringify(arr)
                                    })
                                );
                            }
                        }
                        break;
                    case "SelectObject":
                        console.log("element.value", element.value);
                        if (
                            element.value.replace(/(^s*)|(s*$)/g, "").length !== 0
                        ) {
                            formEd.push(element);
                        }
                        break;
                    case "RadioGroup":
                        if (
                            element.value !== null 
                            && element.value !== undefined 
                            && element.value !== ""
                        ) {
                            formEd.push(element);
                        }
                        break;
                    case "CheckboxGroup":
                        if (element.value.length > 0) {
                            formEd.push(element);
                        }
                        break;
                    case "Cascader":
                        if (element.value.length >= 2) {
                            formEd.push(
                                Object.assign({}, element, {
                                    value: element.value[element.valueIndex]
                                })
                            );
                        }
                        break;
                    default:
                        break;
                }
            }, this);
            console.log("formEd", formEd);
            return formEd;
        },
        handleSearch() {
            search.globalSetFilterWithSearchForm(
                this.tableSearch,
                this.filterForm()
            );
            this.tableLoadEvent();

            this.$emit("handleSearch", this.filterForm());
        },
        resetSearch() {
            this.form.forEach(function (element) {
                switch (element.type) {
                    case "Input":
                        element.value = "";
                        break;
                    case "Checkbox":
                        element.value = false;
                        break;
                    case "Switch":
                        element.value = true;
                        break;
                    case "Daterange":
                        element.value = [];
                        break;
                    case "DateTimeRange":
                        element.value = [];
                        break;
                    case "Date":
                        element.value = "";
                        break;
                    case "Select":
                        element.value = [];
                        break;
                    case "RadioGroup":
                        element.value = "";
                        break;
                    case "CheckboxGroup":
                        element.value = [];
                        break;
                    case "Cascader":
                        element.value = [];
                        break;
                    case "SelectObject":
                        element.value = "";
                        break;
                    default:
                        break;
                }
            }, this);

            this.$emit("handleSearch", []);
        },
        onSelectChange(item) {
            if (item.change) {
                item.change(item);
            }
        },
        handleExport() {
            this.$emit("export");
        },
        formatDate(dateA) {
            let a = dateA[0];
            let aJson = new Date(a).toJSON();
            let aNewDate = new Date(+new Date(aJson) + 8 * 3600 * 1000)
                .toISOString()
                .replace(/T/g, " ")
                .replace(/\.[\d]{3}Z/, "");

            let b = dateA[1];
            let bJson = new Date(b).toJSON();
            let bNewDate = new Date(+new Date(bJson) + 8 * 3600 * 1000)
                .toISOString()
                .replace(/T/g, " ")
                .replace(/\.[\d]{3}Z/, "");

            dateA[0] = aNewDate;
            dateA[1] = bNewDate;
        },
        formatSingleDate(date) {
            let aJson = new Date(date).toJSON();
            return new Date(+new Date(aJson) + 8 * 3600 * 1000)
                .toISOString()
                .replace(/T/g, " ")
                .replace(/\.[\d]{3}Z/, "");
        },
        formatSingleDateAddOnyDay(date) {
            let dateTime = new Date(date);
            dateTime.setDate(dateTime.getDate() + 1);
            let aJson = dateTime.toJSON();
            return new Date(+new Date(aJson) + 8 * 3600 * 1000)
                .toISOString()
                .replace(/T/g, " ")
                .replace(/\.[\d]{3}Z/, "");
        }
    }
};
</script>

<style lang="less" scoped>
.search-card {
    .card-base();
    margin: 20px;
    position: relative;

    .search-form {
        padding: 24px 0;

        .search-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 20px;
            padding: 0 4px;

            .action-btn {
                .button-base();
                transform: translateY(-1px);
                min-width: 20px;

                &.ivu-btn-primary {
                    background: linear-gradient(
                        135deg,
                        #667eea 0%,
                        #764ba2 100%
                    );
                    border: none;

                    &:hover {
                        background: linear-gradient(
                            135deg,
                            #5a6fd8 0%,
                            #6a4190 100%
                        );
                    }
                }

                &.ivu-btn-success {
                    background: linear-gradient(
                        135deg,
                        #56ab2f 0%,
                        #a8e6cf 100%
                    );
                    border: none;

                    &:hover {
                        background: linear-gradient(
                            135deg,
                            #4a9629 0%,
                            #96d4b8 100%
                        );
                    }
                }

                &.ivu-btn-default {
                    background: linear-gradient(
                        135deg,
                        #f8f9fa 0%,
                        #e9ecef 100%
                    );
                    color: #495057;
                    border: 1px solid rgba(0, 0, 0, 0.1);

                    &:hover {
                        background: linear-gradient(
                            135deg,
                            #e9ecef 0%,
                            #dee2e6 100%
                        );
                        color: #343a40;
                    }
                }
            }
        }
    }
}

.not-star {
    .ivu-form-item-required .ivu-form-item-label:before {
        content: "";
    }

    .ivu-form-item {
        margin-bottom: 12px;

        .ivu-form-item-label {
            font-weight: 600;
            color: #262626;
            font-size: 14px;
            line-height: 1.6;
        }

        .ivu-input,
        .ivu-select,
        .ivu-date-picker {
            border-radius: 6px;
            border: 1px solid #d9d9d9;
            transition: all 0.3s ease;

            &:hover {
                border-color: #667eea;
                box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
            }

            &:focus {
                border-color: #667eea;
                box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
            }
        }

        .ivu-input-prefix {
            i {
                color: #667eea;
                font-size: 16px;
            }
        }

        .ivu-select-selection {
            border-radius: 6px;
        }

        .ivu-date-picker {
            width: 100%;
        }
    }

    .ivu-select-dropdown {
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    }

    .ivu-select-item {
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
            background-color: rgba(102, 126, 234, 0.1);
            color: #667eea;
        }

        &.ivu-select-item-selected {
            background-color: rgba(102, 126, 234, 0.15);
            color: #667eea;
            font-weight: 600;
        }
    }
}

// 通用样式混入
.button-base() {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 10px 20px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: none;
    outline: none;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
        );
        transition: left 0.5s;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);

        &::before {
            left: 100%;
        }
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    i {
        margin-right: 6px;
        font-size: 16px;
    }
}

.card-base() {
    border-radius: 12px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95) 0%,
        rgba(255, 255, 255, 0.85) 100%
    );
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05),
        inset 0 1px 0 rgba(255, 255, 255, 0.6);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &:hover {
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15),
            0 4px 12px rgba(0, 0, 0, 0.08),
            inset 0 1px 0 rgba(255, 255, 255, 0.8);
        transform: translateY(-2px);
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(
            90deg,
            #667eea 0%,
            #764ba2 50%,
            #f093fb 100%
        );
        border-radius: 12px 12px 0 0;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    &:hover::before {
        opacity: 1;
    }
}

// 响应式设计
@media (max-width: 768px) {
    .search-card {
        margin: 10px;

        .search-form {
            padding: 16px 0;
        }

        .ivu-col {
            margin-bottom: 16px;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .search-actions {
            flex-direction: column;
            gap: 10px;
            margin-top: 16px;
            padding: 0 2px;

            .action-btn {
                width: 100%;
                margin-left: 0 !important;
                min-width: auto;
                padding: 8px 10px;

                i {
                    margin-right: 8px;
                }
            }
        }

        .ivu-form-item {
            .ivu-form-item-label {
                font-size: 13px;
                font-weight: 600;
            }

            .ivu-input,
            .ivu-select,
            .ivu-date-picker {
                font-size: 14px;
            }
        }
    }
}

@media (max-width: 480px) {
    .search-card {
        margin: 8px;
        border-radius: 8px;

        .search-form {
            padding: 12px 0;
        }

        .search-actions {
            gap: 8px;

            .action-btn {
                padding: 10px 14px;
                font-size: 13px;

                i {
                    margin-right: 6px;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
